import { Item } from '../layout'

export function createRouterByMenus(
  projectId: string,
  moudleId: string,
  menus: Menu[],
  _router: Item[] = []
) {
  menus.forEach((e) => {
    if (e.type === 'MENU') {
      const m = {
        path: `/${
          e.variables && e.variables.pageType === 'bigScreen' ? 'bigscreen' : 'preview'
        }/${projectId}/${moudleId}/${e.id}`,
        meta: {
          title: e.title,
          hidden: e.hidden,
          icon: e.variables && e.variables.icon ? e.variables.icon : null,
          id: e.id
        },
        children: [],
        type: e.type
      }
      if (e.children && e.children.length > 0) {
        createRouterByMenus(projectId, moudleId, e.children, m.children)
      }
      _router.push(m)
    } else {
      _router.push({
        path: `/${
          e.variables && e.variables.pageType === 'bigScreen' ? 'bigscreen' : 'preview'
        }/${projectId}/${moudleId}/${e.id}`,
        meta: {
          title: e.title,
          hidden: e.hidden,
          icon: e.variables && e.variables.icon ? e.variables.icon : null,
          id: e.id
        },
        type: e.type
      })
    }
  })
  return _router
}
